import sileo from 'sileo';

const EmploymentOnboardingCardAcknowledgement = new sileo.Model('hqzen', 'employment-onboarding-card-acknowledgement');
const NewlyOnboardedEmploymentCard = new sileo.Model('hqzen', 'newly-onboarded-employment-onboarding-card');
const OnboardingConfiguration = new sileo.Model('hqzen', 'onboarding-configuration');
const OnboardingConfigurationList = new sileo.Model('hqzen', 'onboarding-configuration-list');
const OnboardingConfigurationDetail = new sileo.Model('hqzen', 'onboarding-configuration-detail');
const OnboardingCards = new sileo.Model('hqzen', 'onboarding-cards');
const EmploymentOnboardingCards = new sileo.Model('hqzen', 'employment-onboarding-cards');
const SpecificEmploymentBoardAssignment = new sileo.Model('hqzen', 'specific-employment-board-assignment');
const EmploymentBoard = new sileo.Model('hqzen', 'employment-board');
const MembersEmploymentOnboardingCard = new sileo.Model('hqzen','members-employment-onboarding-card');
const OnboardingCardAttachmentAmazonCredentials = new sileo.Model('hqzen', 'onboarding-card-amazon-form-data');
const Boards = new sileo.Model('hqzen', 'onboarding-configuration-board');
const OnboardingConfigurationAddMembers = new sileo.Model('hqzen', 'onboarded-members');

const state = {
    unAcknowledgeCards: 0
};

const mutations = {
    setUnAcknowledgeCards(state, count) {
        state.unAcknowledgeCards = count;
    }
};

const getters ={};

const actions = {
    fetchSpecificEmploymentOnboardingCards({ commit, state }, filters) {
        return NewlyOnboardedEmploymentCard.objects.filter(filters)
            .then(response => {
                let tempArr = response.employment_onboarding_cards.filter(card => !card?.date_acknowledged);
                commit('setUnAcknowledgeCards', tempArr.length);
                return response;
            }).catch(e => {
                console.error(e);
            });
    },

    getSpecificEmploymentOnboardingCard(context, pk) {
        return NewlyOnboardedEmploymentCard.objects.get(pk);
    },

    updateEmploymentOnboardingCardAcknowledgement(context, data) {
        let signature = data.signature_file;
        let pk = data.pk;

        let formData = new FormData();
        if (signature) {
            return new Promise((resolve, reject) => {
                signature.save(async(blob) => {
                    formData.append('signature', blob, 'signature.png');
                    delete data.signature;
                    delete data.pk;
                    for (let key in data) {
                        formData.append(key, JSON.stringify(data[key]));
                    }
                    try {
                        resolve(await EmploymentOnboardingCardAcknowledgement.objects.update(pk, formData));
                    } catch (response) {
                        reject(JSON.parse(response.response));
                    }
                });
            });
        } else {
            for (let key in data) {
                formData.append(key, JSON.stringify(data[key]));
            }

            return EmploymentOnboardingCardAcknowledgement.objects.update(pk, formData);
        }
    },

    fetchOnboardingConfigurations(context, filters) {
        return OnboardingConfiguration.objects.filter(filters);
    },

    fetchOnboardingConfigurationList(context, filters) {
        return OnboardingConfigurationList.objects.filter(filters);
    },

    fetchOnboardingCards(context, filters) {
        return OnboardingCards.objects.filter(filters);
    },

    fetchSpecificEmploymentBoard(context, pk) {
        return SpecificEmploymentBoardAssignment.objects.get(pk);
    },

    updateSpecificEmploymentBoard(context, data) {
        let pk = data.pk;
        const form = new FormData();
        form.append('board_ids', data.board_ids);

        return SpecificEmploymentBoardAssignment.objects.update({ 'pk': pk }, form);
    },

    getOnboardingConfiguration(context, pk) {
        return OnboardingConfiguration.objects.get(pk);
    },

    getOnboardingConfigurationDetail(context, pk) {
        return OnboardingConfigurationDetail.objects.get(pk);
    },

    updateOnboardingConfiguration(context, data) {
        const form = new FormData();

        form.append('configuration_data', JSON.stringify(data.configuration_data));
        form.append('card_data', JSON.stringify(data.card_data));
        return OnboardingConfiguration.objects
            .update({ 'pk': data.pk }, form)
            .then(function (data) {
                return data;
            });
    },

    fetchEmploymentBoards(context, filters) {
        return EmploymentBoard.objects.filter(filters);
    },

    fetchOnboardingMembersEmployment(context, filters) {
        return MembersEmploymentOnboardingCard.objects.filter(filters);
    },

    fetchOnboardingCardAttachmentAmazonFormData(context, filters) {
        return OnboardingCardAttachmentAmazonCredentials.objects.filter(
        filters).then(data => {
            return data.amazon;
        });
    },

    fetchOnboardingConfigurationBoards(context, filters) {
        return Boards.objects.filter(filters);
    },

    createOnboardingConfiguration(context, data) {
        const form = new FormData();

        form.append('configuration_data', JSON.stringify(data.configuration_data));
        form.append('card_data', JSON.stringify(data.card_data));
        return OnboardingConfiguration.objects
            .create(form)
            .then(function (data) {
                return data;
            });
    },

    fetchOnboardingConfigurationAddMembers(context, filters) {
        return OnboardingConfigurationAddMembers.objects.filter(filters);
    },

    updateOnboardingConfigurationAddMembers(context, data) {
        let pk = data.onboarding_configuration_pk;

        const form = new FormData();
        form.append('employment_pks', data.employment_pks);
        return OnboardingConfigurationAddMembers.objects.update(pk, form);
    },

    fetchEmploymentOnboardingCards(context, filters) {
        return EmploymentOnboardingCards.objects.filter(filters);
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};
